import { render } from "./ShipmentInformation.vue?vue&type=template&id=71ca4397&scoped=true"
import script from "./ShipmentInformation.vue?vue&type=script&lang=js"
export * from "./ShipmentInformation.vue?vue&type=script&lang=js"

import "./ShipmentInformation.vue?vue&type=style&index=0&id=71ca4397&lang=css"
import "./ShipmentInformation.vue?vue&type=style&index=1&id=71ca4397&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ca4397"]])

export default __exports__